/**
 * @generated SignedSource<<6eca3e61e882ac8b563d60979d1c4fdc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsMapContributionTooltip_contributionMarker",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contributionSlug",
      "storageKey": null
    }
  ],
  "type": "ContributionMarker",
  "abstractKey": null
};

node.hash = "9794c04184fb1b275c6fcabd6a1f47e8";

module.exports = node;
